import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LabelSharedComponent } from './label.component';

@NgModule({
    declarations: [
        LabelSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        LabelSharedComponent
    ]
})

export class LabelSharedModule {}
